import { Component, OnInit, OnDestroy, EventEmitter, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Location } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil, switchMap } from 'rxjs/operators';
import { trigger, style, transition, animate } from '@angular/animations';
import { LoginService } from 'src/app/services/login/login.service';
import { SessionData } from 'src/app/domain/session-data';
import { UserData } from 'src/app/domain/user-data';
import { SessionDataService } from 'src/app/services/session-data/session-data.service';
import { UserDataService } from 'src/app/services/user-data/user-data.service';
import { CaptchaService } from 'src/app/services/captcha/captcha.service';
import { DecodeParamsService } from 'src/app/services/decode-params/decode-params.service';
import { URL_BRANCH } from 'src/app/shared/config-urls';
import { AmountPipe } from 'src/app/pipes/amount.pipe';
import { PreloadedCaptchaAPIService } from 'src/app/services/preloaded-captcha/preloaded-captcha-api.service';
import { TYPE_PAG_CARREGAMENTOS_AGENDADOS, TYPE_PAG_STATE_AGENDADOS, TYPE_CANCEL_LOTE_CARREGAMENTOS, TYPE_CANCEL_TARGET } from 'src/app/shared/global';
import { TYPE_PAG_SERVICOS, TYPE_PAG_STATE, TYPE_PAG_CARREGAMENTOS } from 'src/app/shared/global';
import { TYPE_CANCEL_SEPA_PERIODIC, TYPE_CANCEL_SEPA, TYPE_CANCEL_SERVICOS, TYPE_CANCEL_CARREGAMENTOS} from 'src/app/shared/global';
import { TYPE_CANCEL_IPS_PERIODIC, TYPE_CANCEL_ESTADO, TYPE_PAG_SERVICOS_AGENDADOS, TYPE_CANCEL_IPS} from 'src/app/shared/global';
import { TYPE_PAYMENTS_TSU, TYPE_PAYMENTS_FUTURE_TSU} from 'src/app/shared/global';
import { UserinfoService } from 'src/app/services/user-info/user-info.service';
import { TYPE_CANCEL_PAG_SERVICOS_PONTUAL, TYPE_CANCEL_TSU_PONTUAL } from '../../shared/global';
import { TYPE_CANCEL_SEPA_PONTUAL, TYPE_CANCEL_SWIFT_PONTUAL, TYPE_CANCEL_IPS_PONTUAL} from 'src/app/shared/global';
import { TYPE_CANCEL_PAG_ESTADO_PONTUAL, TYPE_CANCEL_TARGET_PONTUAL, TYPE_CANCEL_CARREGAMENTOS_PONTUAL} from 'src/app/shared/global';
import { TYPE_SEG_SOCIAL, TYPE_SEG_SOCIAL_SCHEDULE, TYPE_CANCEL_SEG_SOCIAL_SCHEDULE } from '../../shared/global';
import { TYPE_TRF_SEPA_SCHEDULE, TYPE_TRF_IPS_SCHEDULE, CANCEL_PAYMENTS_TSU } from '../../shared/global';
import { PaymentBusinessService } from '../../services/payment-business/payment-business.service';
import { RequestProviderService } from '../../services/request-provider/request-provider.service';
import { TYPE_LOTE_PAG_ESTADO, TYPE_CANCEL_LOTE_PAG_ESTADO } from '../../shared/global';
import { TYPE_LOTE_PAG_SERVICOS, TYPE_CANCEL_LOTE_PAG_SERVICOS } from '../../shared/global';
import { ConfigService } from 'src/app/shared/config';

@Component({
  selector: 'app-login-component',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  providers: [LoginService],
  animations: [
    trigger('showDivTrigger', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('1.5s', style({ opacity: 1 })),
      ]),
      transition(':leave', [
        animate('0.1s', style({ opacity: 0 }))
      ])
    ])
  ]
})

export class LoginComponent implements OnInit, OnDestroy {
  sessionData: SessionData;
  userData: UserData;
  hasError: boolean;
  isToShowReember: boolean;
  isLoading: boolean;
  isInitialLoading: boolean;
  messageTitle: string;
  messageDescription: string;
  showCaptcha: boolean;
  answeredCaptcha: boolean;
  captchaResponse: string;
  captchaSiteKey: string;
  branchURL: string;
  rejectLink: string;
  messageOperation: string;
  processTitleOperation: string;
  operationIndicator: string;
  selectedChannel: string;
  username: string;
  password: string;
  @Output() initialDataLoaded: EventEmitter<any> = new EventEmitter();

  private unsubscribe: Subject<void> = new Subject();

  loginForm = this.fb.group({
    username: ['', ''],
    password: ['', ''],
    selectedChannel: ['', Validators.required]
  });


  constructor(public translate: TranslateService,
    private location: Location,
    private router: Router,
    private fb: FormBuilder,
    private sessionService: SessionDataService,
    private loginService: LoginService,
    private route: ActivatedRoute,
    private userDataService: UserDataService,
    private captchaService: CaptchaService,
    private decodeParamsService: DecodeParamsService,
    private captchaLoader: PreloadedCaptchaAPIService,
    private userInfoService: UserinfoService,
    private paymentBusinessService: PaymentBusinessService,
    private requestProviderService: RequestProviderService,
    private configService: ConfigService) {
  }

  getTranslate(): TranslateService {
    return this.translate;
  }

  ngOnInit() {
    this.loadScript('../assets/js/gtm.js', 'script');
    this.loadScript('../assets/js/no-gtm.js', 'noscript');
    this.cleanSessionValues();
    this.isInitialLoading = true;
    const id = this.route.snapshot.paramMap.get('id');
    const aisp = this.router.url.indexOf('AISP') !== -1;
    const pisp = this.router.url.indexOf('PISP') !== -1;
    this.sessionData = new SessionData();
    this.isLoading = false;
    this.hasError = false;
    this.isToShowReember = false;
    this.branchURL = `${URL_BRANCH}`;
    this.sessionData.entryParam = id;

    this.configService.get().pipe(takeUntil(this.unsubscribe)).subscribe(
      (conf: any) => {
        this.captchaSiteKey = `${conf.ob_captcha_key}`;
      }
    );

    if (aisp) {
      this.sessionData.agreementType = 'A';
    } else if (pisp) {
      this.sessionData.agreementType = 'P';
    }

    this.sessionService.setSessionData(this.sessionData)
    .pipe(takeUntil(this.unsubscribe), switchMap((_) => this.decodeParamsService.decryptUrl(this.sessionData, id)))
    .subscribe(
      (response: any) => {
        if (response.statusCode === 'SUCCESS') {
          this.processAgreementData(response);
          this.messageOperationType();
          this.sessionService.setSessionData(this.sessionData).subscribe();
        } else {
          this.router.navigate(['error'], { relativeTo: this.route.pathFromRoot[0] });
        }
        this.isInitialLoading = false;
        this.initialDataLoaded.emit(null);
      }, (error: any) => {
        if (error.status === 400 && this.sessionData.isApp) {
          this.sessionData.requestExpired = true;
          this.sessionService.setSessionData(this.sessionData).subscribe(
            (_) => this.router.navigate(['error'], { relativeTo: this.route.pathFromRoot[0] })
          );
        } else {
        this.router.navigate(['error'], { relativeTo: this.route.pathFromRoot[0] });
      }
      }
    );
  }

  processAgreementData(output: any) {
    if (output.agreementType === 'A') {
      this.sessionData.agreementId = output.A1;
      this.sessionData.entityName = output.A2;
      this.sessionData.providerLink = output.A4;
      this.sessionData.agreementMap = output.UI;
      this.operationIndicator = output.A6;

    } else if (output.agreementType === 'P') {
      this.sessionData.agreementId = output.P1;
      this.sessionData.paymentType = output.P3;
      this.sessionData.entityName = output.P4;
      this.sessionData.paymentAmount = output.P5;
      this.sessionData.paymentAmount = new AmountPipe().transform(this.sessionData.paymentAmount);
      this.sessionData.paymentCurrency = output.P6;
      this.sessionData.paymentBenef = output.P7;
      this.sessionData.isToSelectPaymentAccount = output.P8;
      this.sessionData.providerLink = output.P10;
      this.sessionData.agreementMap = output.UI;
      this.sessionData.numberDetails = output.P14;
      this.operationIndicator = output.P17;

    } else {
      this.router.navigate(['error'], { relativeTo: this.route.pathFromRoot[0] });
    }

    let channel;
    if (this.operationIndicator === 'P') {
      channel = 'P';
    } else if (this.operationIndicator === 'E' || this.router.url.indexOf('empresas') !== -1) {
      channel = 'E';
    } else {
      channel = 'P';
    }

    this.setChannel(channel);

    this.loginForm = this.fb.group({
      username: ['', ''],
      password: ['', ''],
      selectedChannel: [channel, Validators.required]
    });

    this.rejectLink = this.sessionData.providerLink;
    if (!this.rejectLink.startsWith('https://') && !this.rejectLink.startsWith('http://')) {
      this.rejectLink = 'http://' + this.rejectLink;
      this.sessionData.providerLink = this.rejectLink;
    }
  }

  getSessionData(): void {
    this.sessionService.getSessionData()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(sessionData => this.sessionData = sessionData);
  }

  doLogin() {
    if (this.isLoading) {
      // Already loading before
      return;
    }

    if (!this.loginForm.value.username && !this.loginForm.value.password) {
      this.showErrorMessage('LOGIN.DADOS_INCORRECTOS', 'LOGIN.UTILIZADOR_PASSWORD_PREENCHIMENTO_OBRIGATIORIO');
      return;
    } else if (!this.loginForm.value.username) {
      this.showErrorMessage('LOGIN.DADOS_INCORRECTOS', 'LOGIN.UTILIZADOR_PREENCHIMENTO_OBRIGATIORIO');
      return;
    } else if (!this.loginForm.value.password) {
      this.showErrorMessage('LOGIN.DADOS_INCORRECTOS', 'LOGIN.PASSWORD_PREENCHIMENTO_OBRIGATIORIO');
      return;
    }

    const fingerprint = document.getElementById('P2hoCyPjpg').getAttribute('value');

    const sessionToken = document.getElementById('sessiontoken').getAttribute('value');

    this.isLoading = true;
    const user = this.loginForm.value.username;
    this.sessionData.username = user.trim();
    this.sessionData.channel = this.loginForm.value.selectedChannel;
    this.sessionData.selectedLanguage = this.translate.currentLang;
    this.sessionData.fToken = fingerprint;
    this.sessionData.P2hoCyPjpg = sessionToken;


    this.sessionService.setSessionData(this.sessionData).pipe(takeUntil(this.unsubscribe)).subscribe();

    if (this.showCaptcha) {
      this.requestCaptchaLogin();
    } else {
      this.requestLogin();
    }
  }

  cleanSessionValues() {
    sessionStorage.removeItem('sessionData');
    sessionStorage.removeItem('userData');
    sessionStorage.removeItem('paymentAgreementData');
    sessionStorage.removeItem('accountAgreementData');
  }

  showErrorMessage(messageTitle: string, messageDescription: string) {
    this.hasError = true;
    this.isToShowReember = false;
    this.isLoading = false;
    this.messageTitle = messageTitle;
    this.messageDescription = messageDescription;
  }

  requestCaptchaLogin() {
    this.captchaService.validateCaptcha(this.captchaResponse, this.sessionData)
    .pipe(takeUntil(this.unsubscribe))
    .subscribe((_) => {
        this.hasError = false;
        this.requestLogin();
      }, (_) => {
        this.hasError = true;
        this.isLoading = false;
        this.showCaptcha = false;
        this.messageTitle = 'ERROR.OCORREU_UM_ERRO';
        this.messageDescription = 'ERROR.CONTACTAR_ENTIDADE';
      }
    );
  }

  requestLogin() {

    // Invocar serviço login
    this.loginService.doLogin(this.loginForm.value.password)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((response: any) => {
          this.hasError = false;
          this.showCaptcha = false;
          if (response.statusCode === 'SUCCESS') {
            const errors = this.validateLoginData(this.sessionData, response);
            this.messageTitle = 'ERROR.OCORREU_UM_ERRO';
            this.messageDescription = 'ERROR.CONTACTAR_ENTIDADE';
            if (errors > 0) {
              this.hasError = true;
              this.isToShowReember = false;
              this.isLoading = false;
              this.messageTitle = 'LOGIN.DADOS_INCORRECTOS';
              this.messageDescription = 'LOGIN.UTILIZADOR_OU_CODIGO_INCORRECTO';
            } else {
              this.hasError = false;
              this.processLoginData(this.sessionData, response);

                if (this.sessionData.channel === 'E') {
                  this.processUserData();
                } else {
                  this.router.navigate(['confirmation'], { relativeTo: this.route.pathFromRoot[0] });
                }
              }
          } else if (response.statusCode === 'ERROR') {
            this.processLoginError(response);
          } else if (response.statusCode === 'WARNING') {
            this.hasError = true;
            this.isLoading = false;
          }
      }, (response: any) =>  {
        if (response.status === 400) {
          this.sessionData.requestExpired = true;
          this.sessionService.setSessionData(this.sessionData).subscribe(
            (_) => this.router.navigate(['error'], { })
          );
        }
          this.hasError = true;
          this.isLoading = false;
          this.showCaptcha = false;
          this.isToShowReember = false;
          this.messageTitle = 'ERROR.OCORREU_UM_ERRO';
          this.messageDescription = 'ERROR.CONTACTAR_ENTIDADE';
      });
  }

  processLoginError(response: any) {
    this.isToShowReember = false;
    this.isLoading = false;
    if (response.message === 'ERROR_REQUIRES_CAPTCHA') {
      this.showCaptcha = true;
      this.answeredCaptcha = false;
    } else if (response.message === 'ERROR_ACCOUNT_LOCKED') {
      this.hasError = true;
      this.showCaptcha = false;
      this.messageTitle = 'LOGIN.TEMPORIARIAMENTE_INDISPONIVEL';
      this.messageDescription = 'LOGIN.UTILIZADOR_BLOQUEADO';
    } else if (response.message === 'ERROR_WRONG_CREDENTIALS') {
      this.hasError = true;
      this.showCaptcha = false;
      this.messageTitle = 'LOGIN.DADOS_INCORRECTOS';
      this.messageDescription = 'LOGIN.UTILIZADOR_OU_CODIGO_INCORRECTO';
    } else if (response.message === 'ERROR_USERNAME_MAX_LENGTH') {
      this.hasError = true;
      this.showCaptcha = false;
      this.messageTitle = 'LOGIN.DADOS_INCORRECTOS';
      this.messageDescription = 'LOGIN.UTILIZADOR_PREENCHIMENTO_INCORRECTO';
    } else if (response.message === 'ERROR_USER_NEEDS_SAF') {
      this.hasError = true;
      this.showCaptcha = false;
      if (this.sessionData.channel === 'P') {
        this.messageTitle = 'ERROR.ERRO_SAF_TITLE_NBP';
        this.messageDescription = 'ERROR.ERRO_SAF_NBP_DESCRIPTION';
      } else if (this.sessionData.channel === 'E') {
        this.messageTitle = 'ERROR.ERRO_SAF_TITLE';
        this.messageDescription = 'ERROR.ERRO_SAF_NBE_DESCRIPTION';
      }
    } else if (response.message === 'ERROR_HB964') {
      this.showErrorMessage('ERROR.OCORREU_UM_ERRO', 'ERROR.ERRO_IMPOSSIVEL_CONCLUIR_MOTIVOS_SEGURANCA');  
    } else if (response.message === 'ERROR_MISSING_REQUIRED_CREDENTIALS') {
      this.showErrorMessage('LOGIN.DADOS_INCORRECTOS', 'LOGIN.UTILIZADOR_PASSWORD_PREENCHIMENTO_OBRIGATIORIO');
    } else if (response.message === 'ERROR_MISSING_REQUIRED_USERNAME') {
      this.showErrorMessage('LOGIN.DADOS_INCORRECTOS', 'LOGIN.UTILIZADOR_PREENCHIMENTO_OBRIGATIORIO');
    } else if (response.message === 'ERROR_MISSING_REQUIRED_PASSWORD') {
      this.showErrorMessage('LOGIN.DADOS_INCORRECTOS', 'LOGIN.PASSWORD_PREENCHIMENTO_OBRIGATIORIO');
    } else if (response.message === 'ERROR_INVALID_CCI_STATE') {
      this.showErrorMessage('ERROR.OCORREU_UM_ERRO', 'LOGIN.CONTACTAR_EMPRESA');
    } else if (response.message === 'ERROR_INVALID_CCI_FIRST_LOGIN') {
      this.showErrorMessage('ERROR.OCORREU_UM_ERRO', 'LOGIN.LOGIN_APP');
    } else {
      this.hasError = true;
      this.isLoading = false;
      this.showCaptcha = false;
      this.isToShowReember = false;
      this.messageTitle = 'ERROR.OCORREU_UM_ERRO';
      this.messageDescription = 'ERROR.CONTACTAR_ENTIDADE';
    }
  }

  processUserData() {
    return this.userInfoService.getUserInfo(this.sessionData, this.getUserData())
    .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        (userData: any) => {
          this.storeUserData(userData);
          if (this.isLoteOperation() && !this.isCancelLotes()) {
            this.router.navigate(['confirmation/lotes'], { relativeTo: this.route.pathFromRoot[0], skipLocationChange: true });
          } else {
          this.router.navigate(['confirmation'], { relativeTo: this.route.pathFromRoot[0] });
          }
        },
        (_) => {
          this.processGenericError();
        });
  }

  storeUserData(userData: UserData) {
    if (!userData) {
      this.messageTitle = 'ERROR.OCORREU_UM_ERRO';
      this.messageDescription = 'ERROR.ERRO_GENERICO';
      return;
    }

    if (!this.userData) {
      this.userData = userData;
    }

    if (this.sessionData.channel === 'E') {
      this.userData.mobilePhone = userData.mobilePhone;
      this.userData.companyId = userData.companyId;
      this.userData.companyName = userData.companyName;
    }

    if (!this.userData.mobilePhone) {
      this.messageTitle = 'SMS.NAO_EXISTE_TELEMOVEL';
      this.messageDescription = 'SMS.DESCRICAO_NAO_EXISTE_TELEMOVEL';
      return;
    }

    this.userDataService.setUserData(this.userData).subscribe();
    return this.userData;
  }

  getUserData() {
    this.userDataService.getUserData()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(userData => this.userData = userData);
    return this.userData;
  }

  processGenericError() {
    this.isLoading = false;
    this.messageTitle = 'ERROR.OCORREU_UM_ERRO';
    this.messageDescription = 'ERROR.ERRO_GENERICO';
  }

  changeLanguage() {
    this.captchaLoader.updateLanguage(this.translate.currentLang);
  }

  doReject(): void {
    this.location.back();
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  processLoginData(sessionData: SessionData, response: any) {
    sessionData.isLoginOk = true;

    if (sessionData.channel === 'P') {
      this.sessionData.securityToken = response.accessToken;
      this.sessionData.safActivated = response.details.AUTF;

      this.userData = new UserData();
      this.userData.username = sessionData.username;
      this.userData.channel = sessionData.channel;
      this.userData.mobilePhone = response.details.NTEL;
      this.userData.canSignOperations = 'true';
    } else if (sessionData.channel === 'E') {

      this.userData = new UserData();
      this.userData.username = sessionData.username;
      this.sessionData.sessionToken = response.sessionToken;
      this.sessionData.securityToken = response.authorizationToken;
    }

    if (response.d718cbf23cc6fcf3585d937dc636a62915654f3b) {
      this.sessionService.setDeviceId(response.d718cbf23cc6fcf3585d937dc636a62915654f3b);
    } else if (response.details) {
      this.sessionService.setDeviceId(response.details.d718cbf23cc6fcf3585d937dc636a62915654f3b);
    }

    this.sessionService.setSessionData(this.sessionData).pipe(takeUntil(this.unsubscribe)).subscribe();

    this.userDataService.setUserData(this.userData).pipe(takeUntil(this.unsubscribe)).subscribe();
  }

  validateLoginData(sessionData: SessionData, response: any) {
    let errors = 0;

    if (sessionData.channel === 'P' || sessionData.channel === 'E') {
      errors += this.validateLoginResponseData(response);
    }

    return errors;
  }

  validateLoginResponseData(response: any) {
    const errors = 0;

    return errors;
  }

  resolved(captchaResponse: string) {
    this.captchaResponse = captchaResponse;
    this.answeredCaptcha = true;
  }

  showHelp() {
    this.isToShowReember = true;
    this.hasError = false;
    this.isLoading = false;
  }

  hideReember() {
    this.isToShowReember = false;
  }

  clearChannelData() {
    this.showCaptcha = false;

    const channel = this.loginForm.value.selectedChannel;
    const iOS = this.isIOS();

    const param = this.sessionData.entryParam;

    this.setChannel(channel);

    if (channel === 'E' && iOS) {

      if (this.sessionData.agreementType === 'A') {
        this.router.navigate([`/empresas/login/AISP/${param}`], {relativeTo: this.route.pathFromRoot[0]});
      } else if (this.sessionData.agreementType === 'P') {
        this.router.navigate([`/empresas/login/PISP/${param}`], {relativeTo: this.route.pathFromRoot[0]});
      }
    } else if (channel === 'P' && iOS) {
      if (this.sessionData.agreementType === 'A') {
        this.router.navigate([`/login/AISP/${param}`], {relativeTo: this.route.pathFromRoot[0]});
      } else if (this.sessionData.agreementType === 'P') {
        this.router.navigate([`/login/PISP/${param}`], {relativeTo: this.route.pathFromRoot[0]});
      }
    }
  }

  messageOperationType() {
      if (this.sessionData.agreementType === 'A') {
        this.messageOperation = 'LOGIN.PARA_AUTORIZAR_ENTIDADE_CONSULTA_CONTAS';
        this.processTitleOperation = 'TITLE.AUTORIZACAO_CONSULTA';
      } else if (this.sessionData.agreementType === 'P') {
        return this.processPaymentTitleMessages();
      }
  }

  processPaymentTitleMessages() {
    if (this.isTransfer() && !this.isScheduleOperation(this.sessionData.paymentType)) {
        this.messageOperation = 'LOGIN.PARA_EFECTUAR_TRANSFERÊNCIA';
        this.processTitleOperation = 'TITLE.TRANSFERENCIA_OPEN_BANKING';
    } else if (this.isTransfer() && this.isScheduleOperation(this.sessionData.paymentType)) {
        this.messageOperation = 'LOGIN.PARA_EFECTUAR_AGENDAMENTO_TRANSFERÊNCIA';
        this.processTitleOperation = 'TITLE.TRANSFERENCIA_OPEN_BANKING';
    } else if (this.sessionData.paymentType === TYPE_PAG_SERVICOS) {
        this.messageOperation = 'LOGIN.PARA_EFECTUAR_PAGAMENTO_SERVICOS';
        this.processTitleOperation = 'TITLE.PAGAMENTO_SERVICOS';
    } else if (this.sessionData.paymentType === TYPE_PAG_SERVICOS_AGENDADOS) {
        this.messageOperation = 'LOGIN.PARA_EFECTUAR_AGEN_PAGAMENTO_SERVICOS';
        this.processTitleOperation = 'TITLE.PAGAMENTO_SERVICOS';
    } else if (this.sessionData.paymentType === TYPE_PAG_STATE) {
        this.messageOperation = 'LOGIN.PAGAMENTOS_ESTADO';
        this.processTitleOperation = 'TITLE.PAGAMENTO_ESTADO';
    } else if (this.sessionData.paymentType === TYPE_PAG_STATE_AGENDADOS) {
        this.messageOperation = 'LOGIN.AGEN_PAGAMENTOS_ESTADO';
        this.processTitleOperation = 'TITLE.PAGAMENTO_ESTADO';
    } else if (this.sessionData.paymentType === TYPE_PAG_CARREGAMENTOS) {
        this.messageOperation = 'LOGIN.PAGA_CARREGAMENTOS';
        this.processTitleOperation = 'TITLE.CARREGAMENTO';
    } else if (this.sessionData.paymentType === TYPE_PAG_CARREGAMENTOS_AGENDADOS) {
        this.messageOperation = 'LOGIN.AGEN_PAGA_CARREGAMENTOS';
        this.processTitleOperation = 'TITLE.CARREGAMENTO';
    } else if (this.isSegSocialOperation()
                && !this.isScheduleOperation(this.sessionData.paymentType)
                && !this.isCancelOperationPayments()) {
        this.messageOperation = 'LOGIN.PAGA_SEG_SOCIAL';
        this.processTitleOperation = 'TITLE.PAGAMENTO_SEG_SOCIAL';
    } else if (this.isSegSocialOperation()
              && this.isScheduleOperation(this.sessionData.paymentType)
              && !this.isCancelOperationPayments()) {
        this.messageOperation = 'LOGIN.AGEN_PAGA_SEG_SOCIAL';
        this.processTitleOperation = 'TITLE.PAGAMENTO_SEG_SOCIAL';
    } else if (this.isCancelOperationTransfer()) {
        this.messageOperation = 'LOGIN.PARA_CANCELAR';
        this.processTitleOperation = 'TITLE.TRANSFERENCIA_OPEN_BANKING';
    } else if (this.isCancelOperationPayments()) {
        this.typeOfCancel();
    } else if (this.isLoteTrfOperation() && !this.paymentBusinessService.isLoteCancelTrfOperation(this.sessionData.paymentType)) {
        if (this.sessionData.numberDetails !== '1') {
          this.messageOperation = 'LOGIN.LOTE_TITLE_TRANSFS';
        } else {
          this.messageOperation = 'LOGIN.LOTE_TITLE_TRANSF';
        }
        this.processTitleOperation = 'TITLE.LOTE_SEPA';
    } else if (this.isCancelLotesTrf()) {
        if (this.sessionData.numberDetails !== '1') {
          this.messageOperation = 'CONFIRMATION.CANC_LOTE_TRANSFS';
        } else {
          this.messageOperation = 'CONFIRMATION.CANC_LOTE_TRANSF';
        }
        this.processTitleOperation = 'TITLE.CANCELAR_LOTE_TRANSF';
      } else if ( this.sessionData.agreementType === 'P' && this.sessionData.paymentType === TYPE_PAYMENTS_TSU) {
        this.messageOperation = 'CONFIRMATION.PAG_TSU_DESCRIPTION';
        this.processTitleOperation = 'LOGIN.PAGAMENTOS_TSU';
      } else if ( this.sessionData.agreementType === 'P' && this.sessionData.paymentType === TYPE_PAYMENTS_FUTURE_TSU) {
        this.messageOperation = 'LOGIN.AGEN_PAGA_TSU';
        this.processTitleOperation = 'LOGIN.PAGAMENTOS_TSU';
    } else if (this.isLotePaymentOperation() || this.isLoteCancelPaymentOperation()) {
      this.processLotePaymentMessages();
      }
  }

  processLotePaymentMessages() {
    if (this.sessionData.paymentType === TYPE_LOTE_PAG_SERVICOS) {
      this.processLoteServicePaymentMessages();
    } else if (this.sessionData.paymentType === TYPE_CANCEL_LOTE_PAG_SERVICOS) {
      this.processCancelLoteServicePaymentMessages();
    } else if (this.sessionData.paymentType === TYPE_LOTE_PAG_ESTADO) {
      this.processLoteStatePaymentMessages();
    } else if (this.sessionData.paymentType === TYPE_CANCEL_LOTE_PAG_ESTADO) {
      this.processCancelLoteStatePaymentMessages();
    }
  }

  processLoteServicePaymentMessages() {
    if (this.sessionData.numberDetails !== '1') {
      this.messageOperation = 'LOGIN.LOTE_TITLE_PAG_SERVICOS_OPS';
    } else {
      this.messageOperation = 'LOGIN.LOTE_TITLE_PAG_SERVICOS_OP';
    }
    this.processTitleOperation = 'TITLE.LOTE_PAG_SERVICOS';
  }

  processCancelLoteServicePaymentMessages() {
    if (this.sessionData.numberDetails !== '1') {
      this.messageOperation = 'LOGIN.CANC_LOTE_PAG_SERVICOS_OPS';
    } else {
      this.messageOperation = 'LOGIN.CANC_LOTE_PAG_SERVICOS_OP';
    }
    this.processTitleOperation = 'TITLE.CANCELAR_LOTE_PAG_SERVICOS';
  }

  processLoteStatePaymentMessages() {
    if (this.sessionData.numberDetails !== '1') {
      this.messageOperation = 'LOGIN.LOTE_TITLE_PAG_ESTADO_OPS';
    } else {
      this.messageOperation = 'LOGIN.LOTE_TITLE_PAG_ESTADO_OP';
    }
    this.processTitleOperation = 'TITLE.LOTE_PAG_ESTADO';
  }

  processCancelLoteStatePaymentMessages() {
    if (this.sessionData.numberDetails !== '1') {
      this.messageOperation = 'LOGIN.CANC_LOTE_PAG_ESTADO_OPS';
    } else {
      this.messageOperation = 'LOGIN.CANC_LOTE_PAG_ESTADO_OP';
    }
    this.processTitleOperation = 'TITLE.CANCELAR_LOTE_PAG_ESTADO';
  }

  isCancelLotesTrf() {
    return this.paymentBusinessService.isLoteCancelTrfOperation(this.sessionData.paymentType);
  }
  typeOfCancel() {
    if (this.sessionData.paymentType === TYPE_CANCEL_ESTADO || this.sessionData.paymentType === TYPE_CANCEL_PAG_ESTADO_PONTUAL)  {
      this.processTitleOperation =  'TITLE.PAGAMENTO_ESTADO';
      this.messageOperation = 'LOGIN.CANCELAR_PAG_ESTADO';
    } else if (this.sessionData.paymentType === TYPE_CANCEL_CARREGAMENTOS
            || this.sessionData.paymentType === TYPE_CANCEL_CARREGAMENTOS_PONTUAL) {
      this.processTitleOperation =  'TITLE.CARREGAMENTO';
      this.messageOperation = 'LOGIN.CANCELAR_CARREGAMENTO';
    } else if (this.sessionData.paymentType === TYPE_CANCEL_SEG_SOCIAL_SCHEDULE) {
      this.processTitleOperation =  'TITLE.AUTORIZACAO_PAGAMENTO';
      this.messageOperation = 'LOGIN.CANCELAR_PAG_SOCIAL';
    } else if (this.sessionData.paymentType === TYPE_CANCEL_SERVICOS || this.sessionData.paymentType === TYPE_CANCEL_PAG_SERVICOS_PONTUAL) {
      this.processTitleOperation =  'TITLE.PAGAMENTO_SERVICOS';
      this.messageOperation = 'LOGIN.CANCELAR_PAG_SERVICOS';
    } else if (this.sessionData.paymentType === CANCEL_PAYMENTS_TSU  || this.sessionData.paymentType === TYPE_CANCEL_TSU_PONTUAL) {
      this.processTitleOperation =  'TITLE.CANC_PAG_TSU';
      this.messageOperation = 'LOGIN.CANCELAR_PAG_TSU';
    }
  }

  isCancelOperationTransfer() {
    return this.sessionData.paymentType === TYPE_CANCEL_SEPA || this.sessionData.paymentType === TYPE_CANCEL_IPS
                                                             || this.sessionData.paymentType === TYPE_CANCEL_IPS_PERIODIC
                                                             || this.sessionData.paymentType === TYPE_CANCEL_SEPA_PERIODIC
                                                             || this.sessionData.paymentType === TYPE_CANCEL_SEPA_PONTUAL
                                                             || this.sessionData.paymentType === TYPE_CANCEL_IPS_PONTUAL
                                                             || this.sessionData.paymentType === TYPE_CANCEL_SWIFT_PONTUAL
                                                             || this.sessionData.paymentType === TYPE_CANCEL_TARGET_PONTUAL
                                                             || this.sessionData.paymentType === TYPE_CANCEL_TARGET;
  }

  isCancelOperationPayments() {
    return  this.sessionData.paymentType === TYPE_CANCEL_SERVICOS || this.sessionData.paymentType === TYPE_CANCEL_ESTADO
                                                                  || this.sessionData.paymentType === TYPE_CANCEL_CARREGAMENTOS
                                                                  || this.sessionData.paymentType === TYPE_CANCEL_SEG_SOCIAL_SCHEDULE
                                                                  || this.sessionData.paymentType === CANCEL_PAYMENTS_TSU
                                                                  || this.sessionData.paymentType === TYPE_CANCEL_PAG_SERVICOS_PONTUAL
                                                                  || this.sessionData.paymentType === TYPE_CANCEL_PAG_ESTADO_PONTUAL
                                                                  || this.sessionData.paymentType === TYPE_CANCEL_CARREGAMENTOS_PONTUAL
                                                                  || this.sessionData.paymentType === TYPE_CANCEL_TSU_PONTUAL;
  }

  isPayment() {
    return this.sessionData.paymentType === TYPE_PAG_SERVICOS || this.sessionData.paymentType === TYPE_PAG_CARREGAMENTOS
                                                              || this.sessionData.paymentType === TYPE_PAG_STATE
                                                              || this.sessionData.paymentType === TYPE_PAG_SERVICOS_AGENDADOS
                                                              || this.sessionData.paymentType === TYPE_PAG_STATE_AGENDADOS
                                                              || this.sessionData.paymentType === TYPE_PAG_CARREGAMENTOS_AGENDADOS
                                                              || this.sessionData.paymentType === TYPE_CANCEL_SERVICOS
                                                              || this.sessionData.paymentType === TYPE_CANCEL_ESTADO
                                                              || this.sessionData.paymentType === TYPE_CANCEL_CARREGAMENTOS
                                                              || this.sessionData.paymentType === TYPE_CANCEL_PAG_SERVICOS_PONTUAL
                                                              || this.sessionData.paymentType === TYPE_CANCEL_PAG_ESTADO_PONTUAL
                                                              || this.sessionData.paymentType === TYPE_CANCEL_CARREGAMENTOS_PONTUAL
                                                              || this.sessionData.paymentType === TYPE_CANCEL_TSU_PONTUAL;
  }

  isTransfer() {
    return this.paymentBusinessService.isTransferOperation(this.sessionData.paymentType);
  }

  isChargingOperation() {
    return (this.sessionData.paymentType === TYPE_PAG_CARREGAMENTOS
         || this.sessionData.paymentType === TYPE_PAG_CARREGAMENTOS_AGENDADOS
         || this.sessionData.paymentType === TYPE_CANCEL_CARREGAMENTOS);
  }

  isSegSocialOperation() {
    return (this.sessionData.paymentType === TYPE_SEG_SOCIAL
      || this.sessionData.paymentType === TYPE_SEG_SOCIAL_SCHEDULE
      || this.sessionData.paymentType === TYPE_CANCEL_SEG_SOCIAL_SCHEDULE);
  }

  isLoteOperation() {
    return this.paymentBusinessService.isLoteOperation(this.sessionData.paymentType);
  }

  isLoteTrfOperation() {
    return this.paymentBusinessService.isLoteTrfOperation(this.sessionData.paymentType);
  }

  isLotePaymentOperation() {
    return this.paymentBusinessService.isLotePaymentOperation(this.sessionData.paymentType);
  }

  isLoteCancelPaymentOperation() {
    return this.paymentBusinessService.isLoteCancelPaymentOperation(this.sessionData.paymentType);
  }

  goToProvider() {
    this.requestProviderService.goToProvider(this.sessionData);
  }

  isCancelLotes() {
    return this.paymentBusinessService.isLoteCancelOperation(this.sessionData.paymentType);
  }

  isScheduleOperation(paymentType: string) {
    return (paymentType === TYPE_TRF_SEPA_SCHEDULE
      || paymentType === TYPE_TRF_IPS_SCHEDULE
      || paymentType === TYPE_PAG_CARREGAMENTOS_AGENDADOS
      || paymentType === TYPE_PAG_STATE_AGENDADOS
      || paymentType === TYPE_PAG_SERVICOS_AGENDADOS
      || paymentType === TYPE_SEG_SOCIAL_SCHEDULE);
  }

  isIOS() {
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
    // iOS 13 detection
    || (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
    || !window['MSStream'] && /iPad|iPhone|iPod/.test(navigator.userAgent);
  }

  loadScript(url: string, tag: any) {
    const body = <HTMLDivElement> document.body;
    const script = document.createElement(tag);
    script.innerHTML = '';
    script.src = url;
    script.async = false;
    script.defer = true;
    body.appendChild(script);
  }

  setChannel(channel: string) {
    this.selectedChannel = channel;
    this.username = '';
    this.password = '';
  }
}
